module.exports = __webpack_public_path__ + "img/Background image 2.806f15a9.jpeg";